const getScrollbarSize = (element) => {
  if (!element) {
    return 0;
  }
  const scrollbarWidth = element.offsetWidth - element.clientWidth;
  const scrollbarHeight = element.offsetHeight - element.clientHeight;
  return Math.max(scrollbarWidth, scrollbarHeight);
};
export {
  getScrollbarSize as g
};
//# sourceMappingURL=scrollbar-size.js.map
